import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E4DFDADF-60F8-4E90-A501-38381F4346A0
 * name unfold-less-vertical
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-less-vertical.svg
 * tags
 */
export const UnfoldLessVerticalIcon = createSvgIcon(<><path d="M5.41,7.41L10,12L5.41,16.59L4,15.17L7.17,12L4,8.83L5.41,7.41M18.59,16.59L14,12L18.59,7.42L20,8.83L16.83,12L20,15.17L18.59,16.59Z" /></>, 'UnfoldLessVerticalIcon');
export default UnfoldLessVerticalIcon